import React from "react";

function ChatIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="36"
      fill="none"
      viewBox="0 0 34 36"
    >
      <rect
        width="31.554"
        height="33.714"
        x="1.383"
        y="0.963"
        stroke="#E6E6E6"
        strokeWidth="0.846"
        rx="15.777"
      ></rect>
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.269"
        d="M22.388 10.25c.765 0 1.5.286 2.041.796.542.51.846 1.2.846 1.921v7.246c0 .72-.304 1.412-.846 1.922a2.981 2.981 0 01-2.041.795h-4.812l-4.812 2.718V22.93h-1.925c-.765 0-1.5-.286-2.041-.795a2.639 2.639 0 01-.846-1.922v-7.246c0-.72.304-1.412.846-1.921a2.981 2.981 0 012.041-.796h11.549z"
      ></path>
    </svg>
  );
}

export default ChatIcon;
